<template>
    <div class="header">
        
        <div class="nav">
            <div class="left">
                <router-link to="/"><div class="item">HOME</div></router-link>
                <router-link to="/article"><div class="item">ARTICLE</div></router-link>
                <!-- <router-link to="/allMagazine"><div class="item">MAGAZINE</div></router-link> -->
                <!-- <router-link to="/activity"><div class="item">STEP INTO</div></router-link> -->
            </div>
            <div class="logo">
                <router-link to="/">
                    <img src="../assets/steppy.png" alt="">
                </router-link>
            </div>
            <div class="right">
                <router-link to="/aboutus"><div class="item">ABOUT & CONTACT US</div></router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Header'
}
</script>
<style scoped>
html,body{
    padding: 0;
    margin: 0;
}
.header{
    width: 100%;
    height: fit-content;
    background-color: #000;
}
::-webkit-scrollbar {
  display: none;
}
a {
    color: #fff;
    text-decoration: none;
    display: inline-flex;
}
.router-link-exact-active {
    color: #fff;
    text-decoration: none;
}
.header .nav .logo{
    width: 8%;
    height: 8vh;
    text-align: center;
    display: flex;
    align-items: center;
}
.header .nav .logo a{
    display: block;
}
.header .nav .logo img{
    width: 80%;
    height: 100%;
    object-fit: contain;
    transition: all 0.5s ease-in-out;
}
.header .nav .logo img:hover{
    width: 90%;
}
.header .nav{
    width: 100%;
    min-width: 999px;
    height: 8vh;
    min-height: 55px;
    line-height: 8vh;
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 10;
}

.header .nav .left{
    width: 46%;
    height: 100%;
}
.header .nav .left .item{
    height: 100%;
    font-size: 0.8vw;
    font-weight: bold;
    line-height: 100%;
    display: inline-flex;
    padding: 0 10px;
    margin: 0 10px;
    transition: all 0.3s ease-in-out;
}
@media screen and (max-height:670px){
  .header .nav .left .item{
    line-height: 55px;
  }
}
.header .nav .left .item:hover{
    transform: scale(1.2);
}
.header .nav .right{
    width: 46%;
    height: 100%;
    text-align: right;
}
.header .nav .right .item{
    height: 100%;
    font-size: 0.8vw;
    font-weight: bold;
    line-height: 100%;
    display: inline-flex;
    padding: 0 10px;
    margin: 0 10px;
    transition: all 0.3s ease-in-out;
}
@media screen and (max-height:670px){
  .header .nav .right .item{
    line-height: 55px;
  }
}
.header .nav .right .item:hover{
    transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue